import axios from 'axios'
import { createLogic, createLogicMiddleware } from 'redux-logic'
import {
  WSS_ENDPOINT_FETCH,
  WSS_ENDPOINT_FETCH_INTEGRATION,
  WSS_ENDPOINT_FETCH_CANCEL,
  wssEndpointFetchFulfilled,
  wssEndpointFetchRejected,
} from '../actions/wss'
import { getPortalGetInfoUrl } from '../api/env'
import { getLoginURL, parseJwtToken } from '../api/login'
import { raiseError } from '../actions/disconnect'
import { routeToClassroomAgentReset } from '../actions/routing'
import { apiConfigResolved } from '../actions/app'
import { history } from 'redux-first-router'
import { saveTokenDetails } from '../actions/login'
import { logger } from './../lib/utils/logger'

export function createConfig (token) {
  return {
    headers: {
      'Authorization': 'Netop ' + token
    }
  }
}

export const getApiConfiguration = async ({ getState, dispatch, httpClient, getInfoUrl }) => {
  const { app: { apiConfig } } = getState()
  if (apiConfig) {
    return apiConfig
  }

  let { data: { apiconfig: responseApiConfig } } = await httpClient.get(getInfoUrl())
  dispatch(apiConfigResolved(responseApiConfig))
  return responseApiConfig
}

export const fetchWssEndpointLogic = createLogic({
  type: WSS_ENDPOINT_FETCH,
  cancelType: WSS_ENDPOINT_FETCH_CANCEL,
  latest: true,

  processOptions: {
    dispatchReturn: false // use returned promise and apply these types
  },

  async process ({ getState, httpClient, getApiConfig, setWindowLocation, getInfoUrl }, dispatch, done) {
    try {
      const { login: { token } } = getState()

      const apiConfig = await getApiConfig({ getState, dispatch, httpClient, getInfoUrl })
      const cmEndpointURL = apiConfig.v4['agent-client']['get-cm-endpoint']

      // get websocket endpoint
      const response = await httpClient.get(cmEndpointURL, createConfig(token))
      let webSocketEndpoint = response.data.endpoint
      dispatch(wssEndpointFetchFulfilled(webSocketEndpoint))
    } catch (error) {
      dispatch(wssEndpointFetchRejected())

      const errorCodes = [401, 403]
      if (error && error.response && errorCodes.includes(error.response.status)) {
        setWindowLocation(getLoginURL(window.location.href))
      } else {
        dispatch(raiseError('error-fetch-endpoint'))
      }
    }

    done()
  }
})

export const wssEndpointFetchIntegrationLogic = createLogic({
  type: WSS_ENDPOINT_FETCH_INTEGRATION,
  cancelType: WSS_ENDPOINT_FETCH_CANCEL,
  latest: true,
  processOptions: {
    dispatchReturn: false,
  },

  async process ({ getState, getApiConfig, httpClient, getInfoUrl }, dispatch, done) {
    const {
      router: { urlToken },
    } = getState()
    try {
      const apiConfig = await getApiConfig({ getState, dispatch, httpClient, getInfoUrl })
      const cmEndpointURL = apiConfig.v4['agent-client']['get-cm-endpoint']
      const accessTokenKey = 'classroomToken'
      const userIdKey = 'userId'
      const accountIdKey = 'accountId'

      let accessToken = sessionStorage.getItem(accessTokenKey)
      if (urlToken) {
        // opened from classroom link
        accessToken = urlToken
        dispatch(routeToClassroomAgentReset()) // reset urlToken in state
        history().replace(history().location.pathname) // clear url query params
      } else {
        // page refresh (no urlToken in query, get connectivity token and userId from storage)
        accessToken = sessionStorage.getItem(accessTokenKey)
        const userId = sessionStorage.getItem(userIdKey)
        const accountId = sessionStorage.getItem(accountIdKey)
        dispatch(saveTokenDetails({ token: accessToken, userId, accountId }))
      }

      // get websocket endpoint
      const response = await httpClient.get(
        `${cmEndpointURL}?integration=impero${urlToken ? '&url=true' : ''}`,
        createConfig(accessToken)
      )
      if (response.data.connectivity) {
        const { token, userId, accountId = null } = parseJwtToken(response.data.connectivity)
        // save the connectivity user token
        dispatch(saveTokenDetails({ token, userId, accountId }))
        sessionStorage.setItem(accessTokenKey, token)
        sessionStorage.setItem(userIdKey, userId)
        sessionStorage.setItem(accountIdKey, accountId)
      }

      let webSocketEndpoint = response.data.endpoint
      dispatch(wssEndpointFetchFulfilled(webSocketEndpoint))
    } catch (error) {
      logger('==== ERROR: wssEndpointFetchIntegrationLogic', error && error.response ? error.response : error)
      dispatch(raiseError('error-fetch-endpoint-classroom'))
    }
    done()
  }
})
const deps = {
  setWindowLocation: (url) => { window.location = url },
  httpClient: axios,
  getInfoUrl: getPortalGetInfoUrl,
  getApiConfig: getApiConfiguration
}
const arrLogic = [fetchWssEndpointLogic, wssEndpointFetchIntegrationLogic]
export const fetchWssEndpointLogicMiddleware = createLogicMiddleware(arrLogic, deps)

